<template>
  <div class="col-md-9 col-lg-10 ml-md-auto">
    <div class="validation py-3 px-5 my-4" v-show="status">
      <p class="m-0">{{status}}</p>
    </div>
    <div class="new-property-form mb-4 p-3 mb-2 text-dark">
      <b-container fluid class="p-0">
        <b-form>
        <div class="bg-light p-4">

          <b-row>
            <b-col lg="2">
              <label class="m-0 font-weight-bold required">{{ $t('administrative_title') }}</label>
            </b-col>
            <b-col lg="10">
              <b-form-input class="form-input" v-model="$v.data.property.administrative_title.$model" :state="validateState('administrative_title')"></b-form-input>
              <b-form-invalid-feedback :state="validateState('administrative_title')">
                <p v-if="!$v.data.property.administrative_title.required">{{ $t('is required').replace('%s', $t('administrative_title')) }}</p>
                <p v-if="!$v.data.property.administrative_title.maxLength">{{ $t('less than').replace('%s', $t('administrative_title')).replace('%d', $v.data.property.administrative_title.$params.maxLength.max) }}</p>
                <p v-if="!$v.data.property.administrative_title.minLength">{{ $t('more than').replace('%s', $t('administrative_title')).replace('%d', $v.data.property.administrative_title.$params.minLength.min) }}</p>
              </b-form-invalid-feedback>
            </b-col>
          </b-row>

          <b-row>
            <b-col lg="2">
              <label class="m-0 required">{{ $t('property_category') }}</label>
            </b-col>
            <b-col lg="4">
              <b-form-select  :options="property_type" class="form-select" v-model="$v.data.property.property_category.$model" :state="validateState('property_category')"></b-form-select>
              <b-form-invalid-feedback :state="validateState('property_category')">
                <p v-if="!$v.data.property.property_category.required">{{ $t('is required').replace('%s', $t('property_category')) }}</p>
              </b-form-invalid-feedback>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">{{ $t('label_sales-status') }}</label>
            </b-col>
            <b-col lg="4">
              <b-form-select :options="newStatus" class="form-select" v-model="data.property.report_status"></b-form-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0 required">{{ $t('prefecture') }}</label>
            </b-col>
            <b-col lg="4">
              <b-form-select :options="prefecture" class="form-select" v-model="data.property.prefecture" :state="validateState('prefecture')"></b-form-select>
              <b-form-invalid-feedback :state="validateState('prefecture')">
                <p v-if="!$v.data.property.prefecture.required">{{ $t('is required').replace('%s', $t('prefecture')) }}</p>
              </b-form-invalid-feedback>
            </b-col>
          </b-row>
        </div>

        <div class="bg-light p-4">
          <b-row>
            <b-col lg="2">
              <label class="m-0 required">{{ $t('language') }}</label>
            </b-col>
            <b-col lg="4">
              <b-form-select v-model="$v.data.property.language.$model" :options="language" class="form-select" :state="validateState('language')"></b-form-select>
              <b-form-invalid-feedback :state="validateState('language')">
                <p v-if="!$v.data.property.language.required">{{ $t('is required').replace('%s', $t('language')) }}</p>
              </b-form-invalid-feedback>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0 required">{{ $t('property_name') }}</label>
            </b-col>
            <b-col lg="10">
              <b-form-input class="form-input" v-model="$v.data.property.property_name.$model" :state="validateState('property_name')"></b-form-input>
              <b-form-invalid-feedback :state="validateState('property_name')">
                <p v-if="!$v.data.property.property_name.required">{{ $t('is required').replace('%s', $t('property_name')) }}</p>
                <p v-if="!$v.data.property.property_name.maxLength">{{ $t('less than').replace('%s', $t('property_name')).replace('%d', $v.data.property.property_name.$params.maxLength.max) }}</p>
                <p v-if="!$v.data.property.property_name.minLength">{{ $t('more than').replace('%s', $t('property_name')).replace('%d', $v.data.property.property_name.$params.minLength.min) }}</p>
              </b-form-invalid-feedback>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">{{ $t('property_price') }}</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input v-currency="{
                  locale: 'ja',
                  currency: null,
                  valueAsInteger: false,
                  distractionFree: true,
                  precision: { min: 0, max: 3 },
                  valueRange: { min: 0 },
                  allowNegative: false,
                }"
                v-model="$v.data.property.property_price.$model"
                class="form-input"
                :state="validateState('property_price')"
              />
              <span class="col-lg-4 col-sm-2">{{ $t('yen') }}</span>
              <b-form-invalid-feedback :state="validateState('property_price')">
                <p v-if="!$v.data.property.property_price.maxLength">{{ $t('less than').replace('%s', $t('property_price')).replace('%d', $v.data.property.property_price.$params.maxLength.max) }}</p>
              </b-form-invalid-feedback>
            </b-col>
            <b-col lg="2">
              <label class="m-0">{{ $t('building_price') }}</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input v-currency="{
                  locale: 'ja',
                  currency: null,
                  valueAsInteger: false,
                  distractionFree: true,
                  precision: { min: 0, max: 3 },
                  valueRange: { min: 0 },
                  allowNegative: false,
                }"
                v-model="$v.data.property.building_price.$model"
                class="form-input"
                :state="validateState('building_price')"
              />
              <span class="col-lg-4 col-sm-2">{{ $t('yen') }}</span>
              <b-form-invalid-feedback :state="validateState('building_price')">
                <p v-if="!$v.data.property.building_price.maxLength">{{ $t('less than').replace('%s', $t('building_price')).replace('%d', $v.data.property.building_price.$params.maxLength.max) }}</p>
              </b-form-invalid-feedback>
            </b-col>
          </b-row>

          <b-row>
            <b-col lg="2">
              <label class="m-0">{{ $t('land_price') }}</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input v-currency="{
                  locale: 'ja',
                  currency: null,
                  valueAsInteger: false,
                  distractionFree: true,
                  precision: { min: 0, max: 3 },
                  valueRange: { min: 0 },
                  allowNegative: false,
                }"
                v-model="data.property.land_price"
                class="form-input"
              />
              <span class="col-lg-4 col-sm-2">{{ $t('yen') }}</span>
            </b-col>
            <b-col lg="2">
              <label class="m-0">{{ $t('yields') }}</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input v-model="data.property.yields" class="form-input"></b-form-input>
              <span class="col-lg-4 col-sm-2">%</span>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">{{ $t('estimated_annual_income') }}</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input v-currency="{
                  locale: 'ja',
                  currency: null,
                  valueAsInteger: false,
                  distractionFree: true,
                  precision: { min: 0, max: 3 },
                  valueRange: { min: 0 },
                  allowNegative: false,
                }"
                v-model="data.property.estimated_annual_income"
                class="form-input"
              />
              <span class="col-lg-4 col-sm-2">{{ $t('yen') }}</span>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2" class="d-flex">
              <label class="m-0">{{ $t('copy') }}</label>
            </b-col>
            <b-col lg="10">
              <b-form-textarea class="form-input" v-model="data.property.copy" rows="6">
              </b-form-textarea>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">{{ $t('main_image') }}</label>
            </b-col>
            <b-col lg="10">
              <b-form-file @change="uploadImage" accept=".jpg, .png, .gif" :placeholder="$t('label_choose-file')" required></b-form-file>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">{{ $t('main_image_caption') }}</label>
            </b-col>
            <b-col lg="10">
              <b-form-input class="form-input" v-model="data.property.mainImage[0].label"></b-form-input>
            </b-col>
          </b-row>
          <div v-for="(image, index) in data.property.subImage" :key="index">
            <b-row>
              <b-col lg="2">
                <label class="m-0">{{ $t('sub_image') }}{{ index + 1 }}</label>
              </b-col>
              <b-col lg="10" class="d-flex align-items-center ml-auto">
                <b-form-file @change="uploadImagesub($event, index)" accept=".jpg, .png, .gif" :placeholder="$t('label_choose-file')" required></b-form-file>
                <span v-if="data.property.subImage.length !== 1" class="btn btn-danger ml-2" @click="deleteImage(index)"><b-icon icon="dash" scale="2"></b-icon></span>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="2">
                <label class="m-0">{{ $t('sub_image_caption') }}{{ index + 1 }}</label>
              </b-col>
              <b-col lg="10">
                <b-form-input class="form-input" v-model="image.label"></b-form-input>
              </b-col>
            </b-row>
          </div>
          <b-row>
            <b-col lg="10" class="ml-auto">
              <span class="btn btn-primary btn-block" @click="addImage()"><b-icon icon="plus" scale="2"></b-icon></span>
            </b-col>
          </b-row>

          <b-row>
            <b-col lg="2">
              <label class="m-0">{{ $t('movie_url') }}</label>
            </b-col>
            <b-col lg="10" v-for="(video, index) in $v.data.property.mainVideo.$each.$iter" :key="index">
              <b-form-input v-model="video.url.$model" class="form-input" :state="validateState('mainVideo')" @input="validateVideo($event)"></b-form-input>
              <small class="form-text text-muted">{{ $t('description-movie_url') }}</small>
              <b-form-invalid-feedback :state="validateState('mainVideo')">
                <p v-if="!video.url.url">{{ $t('invalid', [$t('movie_url')]) }}</p>
              </b-form-invalid-feedback>
            </b-col>
          </b-row>

          <b-row>
            <b-col lg="2">
              <label class="m-0">{{ $t('street_address') }}</label>
            </b-col>
            <b-col lg="10">
              <b-form-input class="form-input" v-model="data.property.street_address"></b-form-input>
            </b-col>
          </b-row>

          <b-row>
            <b-col lg="2" class="d-flex">
              <label class="m-0">{{ $t('nearest_station') }}</label>
            </b-col>
            <b-col lg="10">
              <b-form-textarea class="form-input" v-model="data.property.nearest_station" rows="6"></b-form-textarea>
            </b-col>
          </b-row>

          <b-row>
            <b-col lg="2">
              <label class="m-0">{{ $t('building_area') }}</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input class="form-input" v-model="data.property.building_area"></b-form-input>
              <span class="ml-2">㎡</span>
            </b-col>
            <b-col lg="2">
              <label class="m-0">{{ $t('land_area') }}</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input class="form-input" v-model="data.property.land_area"></b-form-input>
              <span class="ml-2">㎡</span>
            </b-col>
          </b-row>

          <b-row>
            <b-col lg="2">
              <label class="m-0">{{ $t('date_of_construction') }}</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
                <b-form-input class="form-input" v-model="data.property.date_of_construction"></b-form-input>
            </b-col>
            <b-col lg="2">
              <label class="m-0">{{ $t('floor') }}</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input v-model="data.property.floor" class="form-input"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">{{ $t('construction') }}</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input v-model="data.property.construction" class="form-input"></b-form-input>
            </b-col>
            <b-col lg="2">
              <label class="m-0">{{ $t('unit_price') }}</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="data.property.unit_price" class="form-input"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">{{ $t('total_unit') }}</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input v-model="data.property.total_unit" class="form-input"></b-form-input>
            </b-col>
            <b-col lg="2">
              <label class="m-0">{{ $t('number_of_unit_sold') }}</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="data.property.number_of_unit_sold" class="form-input"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">{{ $t('building_coverage_ratio') }}</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input class="form-input" v-model="data.property.building_coverage_ratio"></b-form-input>
              <span class="ml-2">%</span>
            </b-col>
            <b-col lg="2">
              <label class="m-0">{{ $t('floor_area_ratio') }}</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input class="form-input" v-model="data.property.floor_area_ratio"></b-form-input>
              <span class="ml-2">%</span>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">{{ $t('setback') }}</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input class="form-input" v-model="data.property.setback"></b-form-input>
            </b-col>
            <b-col lg="2">
              <label class="m-0">{{ $t('floor_plan_type') }}</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input v-model="data.property.floor_plan_type" class="form-input"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">{{ $t('floor_plan_details') }}</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input class="form-input" v-model="data.property.floor_plan_details"></b-form-input>
            </b-col>
            <b-col lg="2">
              <label class="m-0">{{ $t('facility') }}</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input class="form-input" v-model="data.property.facility"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">{{ $t('current_situation') }}</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input class="form-input" v-model="data.property.current_situation"></b-form-input>
            </b-col>
            <b-col lg="2">
              <label class="m-0">{{ $t('land_rights') }}</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input class="form-input" v-model="data.property.land_rights"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">{{ $t('ground') }}</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="data.property.ground" class="form-input"></b-form-input>
            </b-col>
            <b-col lg="2">
              <label class="m-0">{{ $t('area_of_use') }}</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input v-model="data.property.area_of_use"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">{{ $t('city_planning') }}</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input v-model="data.property.city_planning" class="form-input"></b-form-input>
            </b-col>
            <b-col lg="2">
              <label class="m-0">{{ $t('parking_lot') }}</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input class="form-input" v-model="data.property.parking_lot"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">{{ $t('roadside_situation') }}</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input class="form-input" v-model="data.property.roadside_situation"></b-form-input>
            </b-col>
            <b-col lg="2">
              <label class="m-0">{{ $t('driveway_burden') }}</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input class="form-input" v-model="data.property.driveway_burden"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">{{ $t('main_lighting_surface') }}</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input class="form-input" v-model="data.property.main_lighting_surface"></b-form-input>
            </b-col>
            <b-col lg="2">
              <label class="m-0">{{ $t('delivery_date') }}</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-input class="form-input" v-model="data.property.delivery_date"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">{{ $t('transaction_mode') }}</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="data.property.transaction_mode" class="form-input"></b-form-input>
            </b-col>
            <b-col lg="2">
              <label class="m-0">{{ $t('information_disclousure_date') }}</label>
            </b-col>
            <b-col lg="4" class="align-items-center d-flex">
              <b-form-datepicker v-model="data.property.information_disclousure_date" :placeholder="$t('label_choose-date')"></b-form-datepicker>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">{{ $t('inspection_certificate') }}</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="data.property.inspection_certificate" class="form-input"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">
              <label class="m-0">{{ $t('remarks') }}</label>
            </b-col>
            <b-col lg="10" class="align-items-center d-flex">
              <b-form-input class="form-input" v-model="data.property.remarks"></b-form-input>
            </b-col>
          </b-row>

          <b-row>
            <b-col lg="2">
              <label class="m-0">{{ $t('google_map_html') }}</label>
            </b-col>
            <b-col lg="10">
              <b-form-textarea type="text" class="form-input" @input="validateMap($event)"></b-form-textarea>
              <small class="form-text text-muted">{{ $t('description-google_map_html') }}</small>
            </b-col>
          </b-row>

          <b-row>
            <b-col lg="2">
              <label class="m-0">{{ $t('google_map_url') }}</label>
            </b-col>
            <b-col lg="10">
              <b-form-input type="text" class="form-input" v-model="data.property.google_map_url" :state="validateState('google_map_url')"></b-form-input>
            </b-col>
          </b-row>

          <b-row>
            <b-col lg="2">
              <label class="m-0">{{ $t('chatbot_url') }}</label>
            </b-col>
            <b-col lg="10">
              <b-form-input type="text" v-model="$v.data.property.chatbot_url.$model" :state="validateState('chatbot_url')" class="form-input"></b-form-input>
              <b-form-invalid-feedback :state="validateState('chatbot_url')">
                <p v-if="!$v.data.property.chatbot_url.url">{{ $t('invalid', [$t('chatbot_url')]) }}</p>
              </b-form-invalid-feedback>
            </b-col>
          </b-row>
        </div>
        </b-form>
    </b-container>
    </div>
    <div class="d-flex justify-content-start align-items-center mb-4">
      <a href="#scroll" class="text-white text-decoration-none" v-smooth-scroll><b-button class="py-3 px-5 mr-3" variant="primary" @click="draft">{{ $t('label_save-draft') }}</b-button></a>
      <a href="#scroll" class="text-white text-decoration-none" v-smooth-scroll><b-button class="py-3 px-5" variant="success" @click="publish" :disabled="reachedLimit">{{ $t('label_publish') }}</b-button></a>
    </div>
  </div>
</template>

<script>
import { required, minLength, maxLength, url } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import { prefectures, businessPropertyValues } from '../../../assets/data/values'

export default {
  props: {
    apiType: {
      validator: function (value) {
        return ['member', 'admin'].indexOf(value) !== -1
      },
      default: 'admin'
    },
    reachedLimit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      mainImage: null,
      noFiles: null,
      subImage: [],
      data: {
        property: {
          type: this.$route.params.type,
          page_status: null,
          administrative_title: null,
          property_category: null,
          prefecture: null,
          report_status: null,
          language: null,
          property_name: null,
          copy: null,
          building_price: null,
          property_price: null,
          land_price: null,
          yields: null,
          estimated_annual_income: null,
          street_address: null,
          nearest_station: null,
          building_area: null,
          land_area: null,
          date_of_construction: null,
          floor: null,
          construction: null,
          unit_price: null,
          total_unit: null,
          number_of_unit_sold: null,
          building_coverage_ratio: null,
          floor_area_ratio: null,
          setback: null,
          floor_plan_type: null,
          floor_plan_details: null,
          facility: null,
          current_situation: null,
          land_rights: null,
          ground: null,
          area_of_use: null,
          city_planning: null,
          parking_lot: null,
          roadside_situation: null,
          driveway_burden: null,
          main_lighting_surface: null,
          delivery_date: null,
          transaction_mode: null,
          information_disclousure_date: null,
          inspection_certificate: null,
          remarks: null,
          mainVideo: [{
            url: ''
          }],
          mainImage: [{
            url: '',
            label: ''
          }],
          subImage: [{
            url: '',
            label: ''
          }],
          google_map_url: null,
          chatbot_url: null
        }
      },
      categories: null,
      floors: null,
      construct: null,
      sight: null,
      manage: null,
      transact: null,
      area: null,
      newStatus: [{ text: this.$i18n.t('please_choose') }].concat(businessPropertyValues.reportStatus.map(s => { return { value: s, text: this.$i18n.t(s) } })),
      property_type: [{ text: this.$i18n.t('please_choose'), disabled: true }].concat(Object.values(businessPropertyValues.propertyTypes).flat().map(t => { return { value: t, text: this.$i18n.t(t) } })),
      prefecture: [{ text: this.$i18n.t('please_choose'), disabled: true }].concat(prefectures.map(p => { return { value: p, text: this.$i18n.t(p.charAt(0).toUpperCase() + p.slice(1)) } })),
      language: [
        { value: null, text: this.$i18n.t('please_choose'), disabled: true },
        { value: 'name_ja', text: this.$i18n.t('Japanese') },
        { value: 'name_en', text: this.$i18n.t('English') },
        { value: 'name_zh-cn', text: this.$i18n.t('Simplified Chinese') },
        { value: 'name_zh-tw', text: this.$i18n.t('Traditional Chinese') }
      ],
      status: null
    }
  },
  validations: {
    data: {
      property: {
        administrative_title: {
          required,
          minLength: minLength(5),
          maxLength: maxLength(100)
        },
        property_category: { required },
        prefecture: { required },
        language: { required },
        property_name: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(100)
        },
        building_price: {
          maxLength: maxLength(10)
        },
        property_price: {
          maxLength: maxLength(10)
        },
        mainVideo: { $each: { url: { url } } },
        google_map_url: { url },
        chatbot_url: { url }
      }
    }
  },
  methods: {
    ...mapActions('adminProperty', ['addProperty']),
    validateState (name) {
      const { $dirty, $error } = this.$v.data.property[name]
      return $dirty ? !$error : null
    },
    uploadImage: function (event) {
      if (event.target.files.length === 0) return

      this.mainImage = event.target.files[0]
      this.data.property.mainImage[0].url = this.mainImage.name
      this.noFiles = !event.target.files[0]
    },
    uploadImagesub: function (event, index) {
      if (event.target.files.length === 0) return

      const imageFile = event.target.files[0]
      this.subImage.push(imageFile)
      this.data.property.subImage[index].url = imageFile.name.replace(/ /g, '_')
    },
    validateVideo ($event) {
      if ($event !== null) {
        const find = $event.search('https://vimeo.com/')
        if (find >= 0) {
          let vimeo = $event.split('https://vimeo.com/')
          vimeo = 'https://player.vimeo.com/video/' + vimeo[1]
          this.data.property.mainVideo[0].url = vimeo
        } else {
          let mainVideo = $event.split('watch?v=')
          if (mainVideo[1] !== undefined) {
            mainVideo = mainVideo[0] + 'embed/' + mainVideo[1]
            this.data.property.mainVideo[0].url = mainVideo
          }
        }
      }
    },
    validateMap ($event) {
      if ($event === null) {
        return
      }

      const result = $event.match(/src="([^"]+)"/)
      if (!result) {
        return
      }
      this.data.property.google_map_url = result[1]
    },
    publish () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.status = this.$i18n.t('label_form-error')
      } else {
        const mainVideo = this.data.property.mainVideo.map(el => el.url)
        this.data.property.mainVideo = mainVideo
        this.data.property.page_status = 'published'
        const dataList = { newData: this.data, mainImage: this.mainImage, subImage: this.subImage }
        this.addProperty({ data: dataList, apiType: this.apiType })
        this.resetFields()
        this.$nextTick(() => {
          this.$v.$reset()
        })
        this.status = null
      }
    },
    draft () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.status = this.$i18n.t('label_form-error')
      } else {
        const mainVideo = this.data.property.mainVideo.map(el => el.url)
        this.data.property.mainVideo = mainVideo
        this.data.property.page_status = 'draft'
        if (this.data.property.mainVideo[0].length !== 0) {
          let mainVideo = this.data.property.mainVideo[0].split('watch?v=')
          mainVideo = mainVideo[0] + 'embed/' + mainVideo[1]
          this.data.property.mainVideo[0] = mainVideo
        }
        const dataList = { newData: this.data, mainImage: this.mainImage, subImage: this.subImage }
        this.addProperty({ data: dataList, apiType: this.apiType })
        this.resetFields()
        this.$nextTick(() => {
          this.$v.$reset()
        })
        this.status = null
      }
    },
    addImage () {
      this.data.property.subImage.push({
        url: '',
        label: ''
      })
    },
    resetFields () {
      this.data.property = {
        mainVideo: [{
          url: ''
        }],
        mainImage: [{
          url: '',
          label: ''
        }],
        subImage: [{
          url: '',
          label: ''
        }]
      }
    },
    deleteImage (index) {
      this.data.property.subImage.splice(index, 1)
      this.subImage.splice(index, 1)
    }
  }
}
</script>
<style scoped>
.bg-light:first-child {
  margin-bottom: 1rem;
}
.bg-light .row {
  margin-bottom: .8rem;
  align-items: center;
}
.bg-light > .row:last-child {
  margin-bottom: 0;
}
</style>
